export default "__VITE_ASSET__8g5jhuDO__"